"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOrgPageContactMessageMockData = exports.buildOrganizationPagePublishedMockData = exports.buildOrganizationPageCreatedDraftMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const buildOrganizationPageCreatedDraftMockData = ({ locale = "en", subject = "Introducing your new Organization Page", firstName = "John", organizationPageUrl = "https://www.zeffy.com/en-US/o/organization-page", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    organizationPageUrl,
});
exports.buildOrganizationPageCreatedDraftMockData = buildOrganizationPageCreatedDraftMockData;
const buildOrganizationPagePublishedMockData = ({ locale = "en", subject = "Your Org Page is live 🎉", firstName = "John", organizationName = "Runners for Life", organizationPagePreviewImageUrl = "https://picsum.photos/seed/org-page-preview/1200/860", organizationPageUrl = "https://www.zeffy.com/en-US/o/runners-for-life", organizationPageEditorUrl = "https://www.zeffy.com/en-US/o/organization-page/edit", organizationPageLoginUrl = "https://www.zeffy.com/login?redirection=%2Fen-US%2Fo%2Frunners-for-life&redirectionUrl=%2Fen-US%2Fo%2Frunners-for-life", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    organizationName,
    organizationPagePreviewImageUrl,
    organizationPageUrl,
    organizationPageEditorUrl,
    organizationPageLoginUrl,
});
exports.buildOrganizationPagePublishedMockData = buildOrganizationPagePublishedMockData;
const buildOrgPageContactMessageMockData = ({ locale = "en", subject = "Someone wrote to you through your Org Page", orgName = "Runners for Life", organizationPageUrl = "https://www.zeffy.com/en-US/o/runners-for-life", senderEmail = "jane.doe@gmail.com", visitorMessage = "Hi! I'd love to volunteer at the Chicago Half Marathon in January. Are you still looking for people to help at the water stations?", contactEmailAddress = "contact@runnersforlife.org", contactEmailSettingsUrl = "https://www.zeffy.com/en-US/o/organization-page/edit", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    orgName,
    organizationPageUrl,
    senderEmail,
    visitorMessage,
    contactEmailAddress,
    contactEmailSettingsUrl,
});
exports.buildOrgPageContactMessageMockData = buildOrgPageContactMessageMockData;
